import * as Config from '../../../../../config';
import { useState, useEffect } from "react";
import { useSelector } from 'react-redux';

import useCallbackPlay from '../../../../../hooks/useCallbackPlay';
import usePreviewPlayer from '../../../../../hooks/usePreviewPlayer';
import useTracksToPlaylist from '../../../../../hooks/useTracksToPlaylist';
import useRowAction from './useRowAction';
import useRestrictionTrack from '../../../custom/-APP_TARGET/hooks/useRestrictionTrack';
import useAutomixLoad from '../../../automix/hooks/useAutomixLoad';
import useCart from '../../../cart/hooks/useCart';

const useTrackAccess = (item, idParent, index, removeItem = null, enableActionsAutomix = true, showCart = true) => {
  const isConnected = useSelector( state => state.isConnected );
  const [isEnabled, setEnabled] = useState(true);
  const isProPlus = useSelector( state => state.isProPlus );
  useEffect(() => {
    if (Config.MOD_PRO) {
      if (isProPlus || (!item.is_dj_edit && !item.is_dj_remix && !isProPlus)) {
        setEnabled(true);
      } else if ((item.is_dj_edit || item.is_dj_remix) && !isProPlus) {
        setEnabled(false);
      }
    } else {
      setEnabled(true);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isProPlus]);
  const isRestricted = useRestrictionTrack(item, isEnabled);
  const isDisabled = (!isEnabled || isRestricted);
  const isTombstoned = (item.tombstoned) ? item.tombstoned : null;
  item.disabled = isDisabled; // For DnD
  item.is_dj_edit = (item.is_dj_edit || (item.genre && item.genre.slug === 'dj-edits')); //HOTFIX
  item.dj_edit_allow = (item.is_dj_edit && isProPlus); //DJEdits + Versions

  const callbackPlay = useCallbackPlay(item);
  const playerLoadSong = (_pid) => (e = null) => {
    if (isEnabled && !isRestricted && !isTombstoned) {
      callbackPlay(_pid);
      if (e) {
        e.stopPropagation(); // To avoid row selection
      }
    }
  }
  
  //autoFirstLoadDeck
  useEffect(() => {
    if (item.autoFirstLoadTimeout) { 
      clearTimeout(item.autoFirstLoadTimeout); 
    }
    if (!isConnected && item.autoFirstLoadDeck && item.autoFirstLoadDeck !== null && typeof item.autoFirstLoadDeck === "function") {
      item.autoFirstLoadTimeout = setTimeout(() => {
        item.autoFirstLoadDeck(playerLoadSong);
        item.autoFirstLoadDeck = null; // JUST LOAD ONCE
      }, item.timeoutMS);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConnected])

  // PREVIEW
  const previewPlayer = usePreviewPlayer(item.id, idParent, index);
  const isPreview = previewPlayer.isPreview;
  const stylePreview = (style) => ({
    ...style,
    // height: isPreview ? style.height + Config.GUTTER_PREVIEW : style.height,
  })

  // Automix
  const { loadToAutomix } = useAutomixLoad(item.id, enableActionsAutomix)

  // Cart
  const { addToCart, isInCart } = useCart(item);
  const { addToPlaylist, beginDnD } = useTracksToPlaylist([item], previewPlayer);
  const toStore = () => { if (item.toStore) { window.open(item.toStore, `_blank`); } }
  const { showContextMenu, /*showExtraMenu,*/ ContextMenuContent } = useRowAction(item.id, playerLoadSong, addToPlaylist, toStore, removeItem, isRestricted, loadToAutomix, (showCart && idParent !== 'collection') ? addToCart : null, isTombstoned); // TODO - REWORK

  return {
    isEnabled, isRestricted, isDisabled,
    playerLoadSong,
    previewPlayer, isPreview, stylePreview,
    beginDnD, 
    showContextMenu, /*showExtraMenu,*/ ContextMenuContent,
    addToCart, isInCart,
    addToPlaylist,
    isTombstoned
  };
};

export default useTrackAccess;
